import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["name", "placeholder"]

import { ref, PropType, watch, computed } from "vue";
import { FilterDefinition } from "@/types/search-page";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageFilterOption from "@/components/v2/search-page/SearchPageFilterOption.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageFilterOptions',
  props: {
  filterDefinition: {
    type: Object as PropType<FilterDefinition>,
    required: true,
  },
  showAllFilterOptions: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

const searchText = ref<string>("");

const filterOptions = computed(() => {
  if (props.filterDefinition.maxVisibleOptions && !props.showAllFilterOptions) {
    return searchPageStore
      .filteredSectionResults(props.filterDefinition)
      .slice(0, props.filterDefinition.maxVisibleOptions);
  }

  if (props.showAllFilterOptions) {
    return searchPageStore.filteredSectionResults(props.filterDefinition);
  }

  return props.filterDefinition.options;
});

watch(
  () => props.filterDefinition.search,
  (newValue) => {
    searchText.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _unref(searchPageStore).sectionResultsExceedMaxVisible(__props.filterDefinition) ||
      __props.showAllFilterOptions
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: `${__props.filterDefinition.name}_search`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
            placeholder: `Filter ${__props.filterDefinition.description}...`,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (
        _unref(searchPageStore).updateSectionSearchText(
          ($event.target as HTMLInputElement).value,
          __props.filterDefinition
        )
      ))
          }, null, 40, _hoisted_2), [
            [
              _vModelText,
              searchText.value,
              void 0,
              { trim: true }
            ]
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filterOption) => {
      return (_openBlock(), _createBlock(SearchPageFilterOption, {
        key: filterOption.id,
        filterOption: filterOption,
        filterDefinition: __props.filterDefinition,
        showAllFilterOptions: __props.showAllFilterOptions
      }, null, 8, ["filterOption", "filterDefinition", "showAllFilterOptions"]))
    }), 128)),
    (
      _unref(searchPageStore).sectionResultsExceedMaxVisible(__props.filterDefinition) &&
      !__props.showAllFilterOptions
    )
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "seeall-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(searchPageStore).openFilterModal(__props.filterDefinition.filterCategoryId)))
        }, " See all "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})